import { render } from "./AddModalPrepaidAccount.vue?vue&type=template&id=57b510b4&ts=true"
import script from "./AddModalPrepaidAccount.vue?vue&type=script&lang=ts"
export * from "./AddModalPrepaidAccount.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__